import { render, staticRenderFns } from "./PricePointFilter.template.vue?vue&type=template&id=c9845f60&scoped=true&"
var script = {}
import style0 from "./PricePointFilter.template.vue?vue&type=style&index=0&id=c9845f60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9845f60",
  null
  
)

export default component.exports